<template>
  <b-row>
    <b-col cols="12" v-if="data && data.length > 0">
      <b-row class="py-1" v-for="(corporate, index) in data" :key="index">
        <b-col>
          <b-row class="py-1 border-b border-gray items-center">
            <b-col style="text-transform: uppercase">
              <span class="text-xs font-bold text-capitalize">
                {{ corporate.name }}
              </span>
            </b-col>
            <b-col class="text-xs">
              <b-badge class="bg-orange mr-2">#corporate{{ data.length > 1 ? ' ' + (index + 1) : '' }}</b-badge>
            </b-col>
            <b-col>
              <button type="button" class="bg-blue text-white rounded-sm px-2 py-1 text-xs float-end" @click="show(index)">
                <span v-if="selectedIdx === index">Hide Details</span>
                <span v-else>Show Details</span>
              </button>
            </b-col>
          </b-row>
          <b-row v-if="showDetails && selectedIdx === index" class="mt-2">
            <b-col cols="12">
              <b-row>
                <b-col>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-corporate-name"
                    label="Entity Name"
                    label-for="input-corporate-name">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="corporate.name"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-reg-number"
                    label="Registration Number"
                    label-for="input-reg-number">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="corporate.registrationNumber || '–'"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-reg-date"
                    label="Registration Date"
                    label-for="input-reg-date">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="formatDate(corporate.registrationDate)"
                      required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-corporate-email"
                    label="Email Address"
                    label-for="input-corporate-email">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="corporate.email || '–'"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-corporate-phone"
                    label="Phone Number"
                    label-for="input-corporate-phone">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="corporate.phone || '–'"
                      required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col v-if="corporate.address">
                  <AdminUnitsView :data="corporate.address" :api="api" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12" v-else>
      <div class="text-center py-8 text-gray-500 text-sm">
        <i class="fa fa-user-slash text-3xl mb-2"></i>
        <p>No corporates information available</p>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";
import AdminUnitsView from './AdminUnitsView.vue';

export default {
  name: 'CorporatesView',
  components: { AdminUnitsView },
  props: {
    data: {
      type: Array,
      default: function () { return []; },
    },
    cardinality: {
      type: String,
      default: '',
    },
    api: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showDetails: false,
      selectedIdx: null
    };
  },
  methods: {
    show(idx) {
      if (this.selectedIdx === idx) {
        this.selectedIdx = null;
        this.showDetails = false;
      } else {
        this.selectedIdx = idx;
        this.showDetails = true;
      }
    },
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format("DD/MM/YYYY");
      }
      return "–";
    },
  },
};
</script>

<style scoped>

</style>
